export class FlipbookNew extends HTMLElement {
    toc_map = new Map();
    current_page = 1;

    constructor() {
        super();
    }

    connectedCallback() {
        this.initTocMap();
        this.initEventlisteners();
        this.sendUsageInfo(null);
    }

    initTocMap() {
        // map table of contents items
        const tocList = document.querySelector("ul.sidebar-menu");
        const tocLinks = tocList.querySelectorAll("a[data-page]");
        tocLinks.forEach((link, index) => {
            const pageName = link.querySelector("span").innerText.trim();
            this.toc_map.set(link.dataset.page, pageName);
        });
        // remove elements that don't have full descriptions
        for (const [page, pageName] of this.toc_map.entries()) {
            if (pageName.length < 3) {
                this.toc_map.delete(page);
            } else {
                this.toc_map.set(
                    page,
                    pageName.substring(0, pageName.indexOf("\n")).trim()
                );
            }
        }
    }

    initEventlisteners() {
        document.addEventListener(
            "flipbook-loaded",
            this.initTocMap.bind(this)
        );

        document.addEventListener(
            "page-turn-event",
            this.sendUsageInfo.bind(this)
        );
    }

    sendUsageInfo(event) {
        let pageName = "";
        let turnType = "";
        if (event) {
            let pageNumber = event.detail.page;
            if (this.current_page == pageNumber) {
                return; // no page change
            }
            this.current_page = pageNumber;

            if (event.detail.originalEvent.type == "keydown" && ['ArrowLeft', 'ArrowRight'].includes(event.detail.originalEvent.key)) {
                turnType = "keyboard-arrow";
            } else if (
                event.detail.originalEvent.currentTarget.classList.contains(
                    "radio_selected"
                )
            ) {
                turnType = "toc";
            } else if (
                event.detail.originalEvent.target.classList.contains("outer-gradient") || event.detail.originalEvent.target.classList.contains("page-wrapper")) {
                turnType = "page-corner";
            } else if (event.detail.originalEvent.target.classList.contains('vetology-right') ||
                       event.detail.originalEvent.target.classList.contains('vetology-left')) {
                turnType = "page-arrow";
            } else {
                return; // unknown turn type
            }

            // find the page numbe in the toc map on or before the current page
            pageName = "Cover Page";
            for (const [page, name] of this.toc_map.entries()) {
                if (parseInt(page) <= parseInt(pageNumber)) {
                    pageName = name;
                }
            }
        }

        const formData = new FormData();
        formData.append("case_id", this.dataset.case_id);
        formData.append("turn_type", turnType);
        formData.append("page", pageName);

        // send to home to record analytics
        fetch("/patient/detail/usage-tracking", {
            method: "POST",
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                response.json().then((json) => {
                    if (!json.success) {
                        console.error(
                            "Error recording page turn: " + json.message
                        );
                    }
                });
            })
            .catch((error) => {
                console.error("Error recording page turn:", error);
            });
    }
}

customElements.define("flipbook-new", FlipbookNew);
